"use client";

import { useIsPresentationTool } from "next-sanity/hooks";
import styles from "./DraftIndicator.module.scss";

export const DraftIndicator = () => {
	const isPresentationTool = useIsPresentationTool();

	if (isPresentationTool) return null;

	return (
		<div className={styles["draft"]}>
			<div className={styles["draft__tag"]}>
				Previewing Draft Content.{" "}
				<a href="/api/draft-mode/disable">Disable</a>
			</div>
		</div>
	);
};
